import React from "react";
import SectionHeading from "./sectionHeading";
import ButtonLink from "./buttonLink";
import { useMediaQuery } from "react-responsive";

const SimpleParagrahs = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const autoHeight = content.buttonText?.length > 35 && isMobile;

  return (
    <div id="simpleParagraphs">
      <SectionHeading title={content.title} subtitle={content.subtitle} />
      <div className="paragraphs">
        {content.paragraphs.map((item, i) => (
          <p key={i}>{item.paragraph}</p>
        ))}
      </div>
      {(content.buttonText || content.buttonIsDownload) && <ButtonLink content={content} autoHeight={autoHeight} />}
    </div>
  );
};

export default SimpleParagrahs;
